import Vue from 'vue'
import App from './App.vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router'
import router from "./router";
import site from "./config/config.js"
import ElementUI from 'element-ui';
import store from './store'
import 'element-ui/lib/theme-chalk/index.css';
import "./assets/css/index.css"
import "./assets/css/home.css"
import requests from './utils/axios.js'
import Vant from 'vant';
import 'vant/lib/index.css';

Vue.use(Vant);
Vue.use(Vuex)

// 如此配置即可
// uni.$u.config.unit = 'rpx'
// console.log(api_kefu)
// Vue.prototype.api_kefu = api_kefu;
import {
	Swipe,
	SwipeItem,
	Loading,
	// Toast,
	Lazyload
} from 'vant';
Vue.use(Lazyload);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Loading);
// const store = new Vuex.Store({
// 	state: {
// 		gamelist: [],
// 		isMobile: false,
// 	},
// 	getters: {
// 		isMobile: state => state.isMobile,
// 	},
// 	mutations: {
// 		// 同步异步请求的数据
// 		setList(state, res) {
// 			state.gamelist = res;
// 		},
// 		SET_IS_MOBILE: (state, isMobile) => state.isMobile = isMobile,
// 	}
// })


Vue.prototype.rq = requests
// Vue.prototype.img_url = "http://api.kkzh.com/"
// Vue.prototype.api_url = "http://api.kkzh.com/"
Vue.prototype.img_url = "https://zuhao.bbzsh.com/api-server/"
Vue.prototype.api_url = "https://zuhao.bbzsh.com/api-server/"
// Vue.prototype.img_url = "https://bbzsh.com/api-server/"
// Vue.prototype.api_url = "https://bbzsh.com/api-server/"
// Vue.prototype.img_url = "http://127.0.0.1:20004/"
// Vue.prototype.api_url = "http://127.0.0.1:20004/"
Vue.prototype.fixImageUrl = function(url) {
	if (!url) return ''
	if (typeof url === 'string') {
		if (url.startsWith('https://bbzsh.com')) {
			return url.replace('https://bbzsh.com', 'https://api.bbzsh.com')
		}
		if (url.startsWith('https://zuhao.bbzsh.com')) {
			return url.replace('https://zuhao.bbzsh.com', 'https://api.bbzsh.com')
		}
	}
	return url
}
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(VueRouter)
Vue.use(site)


// 保存原始的 push 方法
const originalPush = VueRouter.prototype.push
// 重写 push 方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    // 只捕获重复导航的异常，其他异常正常抛出
    if (err.name === 'NavigationDuplicated') {
      return Promise.resolve(err) // 静默处理，不报错
    }
    return Promise.reject(err)
  })
}

// 同理重写 replace 方法（可选，根据你的使用场景）
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (err.name === 'NavigationDuplicated') {
      return Promise.resolve(err)
    }
    return Promise.reject(err)
  })
}



new Vue({
	router,
	store: store,
	render: (h) => h(App),
}).$mount("#app");
